import PropTypes from "prop-types"

export const WidgetType = PropTypes.shape({
  data: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  widgetId: PropTypes.string.isRequired,
  params: PropTypes.object,
  subscriptions: PropTypes.object,
  transformer: PropTypes.string,
  reqOpt: PropTypes.shape({
    endpoint: PropTypes.string,
    bodyOpt: PropTypes.object
  })
})

export const ColumnType = PropTypes.shape({
  align: PropTypes.string.isRequired,
  columnType: PropTypes.string.isRequired,
  dataIndex: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  groupable: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  hideable: PropTypes.bool.isRequired,
  lockable: PropTypes.bool.isRequired,
  locked: PropTypes.bool.isRequired,
  multiEdition: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  tree: PropTypes.bool.isRequired
})
